import React, { useMemo, Fragment, useEffect, useState, useContext } from "react";
import { MaterialReactTable, MRT_FullScreenToggleButton, MRT_ShowHideColumnsButton, MRT_ToggleFiltersButton } from "material-react-table";
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate,useOutletContext } from "react-router-dom";
import { useViewThoughtLeadershipResourcesListQuery } from "../../../../reactQueries/AppApi/rqHooksForThoughtLeadershipResources";
import { dateformatConverter } from "../../../../common/utilities/dates/dateformatConverter"
import truncate from "lodash/truncate";
import { thoughtLeadershipResourceEditPath } from "../../../../routes/routePaths";
import MpgErrorDialog from "../../../../common/dialog/MpgErrorDialog";
import NoTableDataComp from "../../../../common/otherCommonComponents/NoTableDataComp";
import HtmlTooltip from "../../../../common/tooltips/HtmlTooltip";
import { useGetLoggedInUserDetails } from "../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import ExportButton from "../../../../common/otherCommonComponents/ExportButton";
import { useTrackActivityMutation } from "../../../../reactQueries/commonRQHooks";
import { getAccessTypes } from "../../../../hooksAndFunctions/functions/getAccessTypes";

const ViewThoughtLeadershipResources = () => {
    const {refClientSpecificCmsData}=useOutletContext();
    const { loggedInUser } = useGetLoggedInUserDetails();
    const { id: userId } = loggedInUser;
    const { mutate: trackActivityMutate } = useTrackActivityMutation();
    const { isEnterpriseAdmin: isEnterpriseAdminType, clientPortalAdminType } = getAccessTypes()
    const { hasA1Access } = clientPortalAdminType

    const canExportXls = isEnterpriseAdminType || hasA1Access;
    const {
        isSuccess,
        isFetching: isFetchingOnTlrData,
        error,
        data: tlrListData,
        isError,
    } = useViewThoughtLeadershipResourcesListQuery();

    /**
     * "Id": "00000000-0000-0000-0000-000000000000",
        "BrandId": "00000000-0000-0000-0000-000000000000",
        "SitecoreId": "153e03eb-a57e-41f7-9dd0-50f83b64d4ef",
        "Title": "AI methods Tools",
        "IsAvailableToAll": true,
        "Availability": "All",
        "Languages": "English,French,French (Canada),Spanish",
        "LanguageModel": null,
        "ResourceType": "Article",
        "ResourceTypeId": "00000000-0000-0000-0000-000000000000",
        "Status": false,
        "thoughtLeadershipResourcesExcludedAccounts": null,
        "CreatedTimeStamp": "0001-01-01T00:00:00+00:00",
        "CreatedBy": "Admin",
        "UpdatedTimeStamp": null,
        "UpdatedBy": null
     */

        const fetchThoughtLeadershipListCMSLabel=(key)=>{
            if(refClientSpecificCmsData?.Components && refClientSpecificCmsData?.Components["ThoughtLeadershipList"]){
               const ThoughtLeadershipListCMSDataLabel=refClientSpecificCmsData?.Components["ThoughtLeadershipList"];
                  return returnLabel(ThoughtLeadershipListCMSDataLabel?.Labels, key)
            }
            return '';
        }
        const fetchCommonComponentCMSLabel=(key)=>{
            if(refClientSpecificCmsData?.Components && refClientSpecificCmsData?.Components["CommonComponent"]){
               const clientSubAccountGroupsListCMSDataLabel=refClientSpecificCmsData?.Components["CommonComponent"];
                  return returnLabel(clientSubAccountGroupsListCMSDataLabel?.Labels, key)
            }
            return '';
        }
        
        const returnLabel = (labelArray=[], key) => {
              return labelArray.find((x) => x.Key === key)?.Phrase || '';
        }

    const thoughtLeadershipTitle = fetchThoughtLeadershipListCMSLabel('ThoughtLeadershipList.ThoughtLeadershipTitle');
    const exportFileName = `${thoughtLeadershipTitle}.xlsx`;
    const exportWorksheetName = thoughtLeadershipTitle;

    const exportColumns = [
        { id: 'Title', header: fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.ResourceTitle"), getValue: (row) => row?.Title || '' },
        { id: 'Availability', header: fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.Availability"), getValue: (row) => row?.Availability || '' },
        { id: 'SitecoreId', header: fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.SitecoreId"), getValue: (row) => row?.SitecoreId || '' },
        { id: 'ResourceType', header: fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.ResourceType"), getValue: (row) => row?.ResourceType || '' },
        { id: 'languages', header: fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.Languages"), getValue: (row) => row?.Languages || '' },
        { id: 'UpdatedBy', header: fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.ModifiedBy"), getValue: (row) => row?.UpdatedBy || '' },
        { id: 'modifiedOn', header: fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.ModifiedOn"), getValue: (row) => row?.UpdatedTimeStamp ? dateformatConverter(row.UpdatedTimeStamp, "DD MMM YYYY hh:mm A") : '' },
    ];

    const columns = useMemo(
        () => [
            {
                accessorKey: "Title",
                header: fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.ResourceTitle"),
                Cell: ({ renderedCellValue }) => {
                    return (
                        <HtmlTooltip title={renderedCellValue}>{renderedCellValue}</HtmlTooltip>
                    )
                },
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder:fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.PlaceholderResourceTitle") }
            },
            {
                accessorKey: "Availability",
                header: fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.Availability"),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder:fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.PlaceholderAvailability") }
            },
            {
                accessorKey: "SitecoreId",
                header: fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.SitecoreId"),
                Cell: ({ renderedCellValue }) => {
                    return (
                        <HtmlTooltip title={renderedCellValue}>{renderedCellValue}</HtmlTooltip>
                    )
                },
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder:fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.PlaceholderSitecoreId") }
            },
            {
                accessorKey: "ResourceType",
                header:fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.ResourceType"),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder:fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.PlaceholderResourceType") }
            },
            {
                accessorFn: (originalRow) => {
                    const lang = originalRow.Languages
                    return lang
                },
                id: 'languages',
                header:fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.Languages"),
                Cell: ({ renderedCellValue }) => {
                    return (
                        <HtmlTooltip title={renderedCellValue}>{renderedCellValue}</HtmlTooltip>
                    )
                },
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder:fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.PlaceholderLanguages") }
            },
            {
                accessorKey: "UpdatedBy",
                header:fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.ModifiedBy"),
                Cell: ({ renderedCellValue }) => {
                    return (
                        <HtmlTooltip title={renderedCellValue}>{renderedCellValue}</HtmlTooltip>
                    )
                },
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder:fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.PlaceholderModifiedBy") }
            },
            {
                accessorFn: (originalRow) => {
                    const data = dateformatConverter(originalRow.UpdatedTimeStamp, "DD MMM YYYY hh:mm A");
                    return `${data}`
                },
                id: 'modifiedOn',
                header:fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.ModifiedOn"),
                filterFn: 'contains',
                sortingFn: 'datetime',
                muiTableHeadCellFilterTextFieldProps: { placeholder:fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.PlaceholderModifiedOn") }
            },
        ],
        []
    );

    /**redirect hook */
    let navigate = useNavigate();

    return (
        <Fragment>
            {
                !!isFetchingOnTlrData && fetchCommonComponentCMSLabel('Common.Waitloading')
            }
            <Typography variant="h5" align="center" sx={{ fontWeight: "bolder" }}>
                {fetchThoughtLeadershipListCMSLabel('ThoughtLeadershipList.ThoughtLeadershipTitle')}
            </Typography>

            {/**incase successful call but empty response */}
            {!!isSuccess && !tlrListData?.length && (<NoTableDataComp />)}

            {!!isSuccess && !!tlrListData?.length && (
                <MaterialReactTable
                    columns={columns}
                    data={tlrListData || []}
                    layoutMode="grid"
                    enableGlobalFilter={false}
                    enableDensityToggle={false}

                    initialState={{
                        density: "compact",
                        showColumnFilters: true,
                    }}
                    state={{
                        isLoading: isFetchingOnTlrData,
                        columnPinning: {
                            left: ['mrt-row-actions', 'Title']
                        }
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                          header: fetchThoughtLeadershipListCMSLabel('ThoughtLeadershipList.Actions'),
                        },
                      }}
                    enableStickyHeader
                    enableRowActions
                    enablePinning
                    renderToolbarInternalActions={({ table }) => (
                        <>
                            {canExportXls && (
                                <ExportButton
                                    table={table}
                                    tooltipTitle={fetchThoughtLeadershipListCMSLabel("ThoughtLeadershipList.ExportToXLS")}
                                    trackActivity={trackActivityMutate}
                                    userId={userId}
                                    exportColumns={exportColumns}
                                    fileName={exportFileName}
                                    worksheetName={exportWorksheetName}
                                />
                            )}
                            <MRT_ToggleFiltersButton table={table} />
                            <MRT_ShowHideColumnsButton table={table} />
                            <MRT_FullScreenToggleButton table={table} />
                        </>
                    )}
                    muiTablePaginationProps={{
                        labelRowsPerPage:fetchCommonComponentCMSLabel('Common.Rowsperpage')
                      }}
                    renderRowActions={({ row, table }) => {
                        const sitecoreId = row.original.SitecoreId;
                        return (
                            <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                                <IconButton
                                    onClick={() => {
                                        navigate(thoughtLeadershipResourceEditPath({ sitecoreId }));
                                    }}
                                >
                                    <EditIcon />
                                </IconButton>
                            </Box>
                        )
                    }}
                />
            )}

            <MpgErrorDialog
                open={!!isError}
            />
        </Fragment>
    );
};

export default ViewThoughtLeadershipResources;
